var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegeplads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1,11.567,11.488,3.984a2.09,2.09,0,0,0-2.035-1.65H5.912A2.079,2.079,0,0,0,3.865,4.043L2.494,11.58a.462.462,0,1,0,.909.166L4.775,4.208a1.154,1.154,0,0,1,1.137-.949h.37v6.812H6.051a.463.463,0,0,0,0,.925H9.274a.463.463,0,0,0,0-.925H9.043V3.259h.41a1.161,1.161,0,0,1,1.13.916l1.607,7.584a.462.462,0,0,0,.452.367.447.447,0,0,0,.1-.01A.463.463,0,0,0,13.1,11.567Zm-4.515-1.5H6.745V3.259H8.58Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegeplads);
export default __webpack_public_path__ + "static/media/LEGEPLADS.9b31add6900f17d768d41d919df87ae1.svg";
export { ForwardRef as ReactComponent };